module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0061.jpg?v=b5df8e98";